import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import './TripPage.css'; // Reuse the excellent styles we just built

export default function NotFoundPage() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    return (
        <div className="trip-page error-state">
            <main className="trip-error-modern">
                <div className="error-content-card">
                    <div className="raisa-avatar-xl">
                        <img src="/raisa.png" alt="Raisa AI" />
                    </div>
                    <h1>{t('not_found.title')}</h1>
                    <p>{t('not_found.subtitle')}</p>

                    <div className="error-actions">
                        <button className="error-primary-btn" onClick={() => navigate({ to: i18n.language.split('-')[0] === 'en' ? '/' : `/${i18n.language.split('-')[0]}` })}>
                            <span className="btn-icon">✨</span>
                            {t('trip.plan_new')}
                        </button>
                    </div>

                    <div className="error-suggestions">
                        <span>{t('trip.popular_starting')}:</span>
                        <div className="suggestion-chips">
                            <button onClick={() => navigate({ to: i18n.language.split('-')[0] === 'en' ? '/' : `/${i18n.language.split('-')[0]}` })} className="chip">{t('trip.city_paris')}</button>
                            <button onClick={() => navigate({ to: i18n.language.split('-')[0] === 'en' ? '/' : `/${i18n.language.split('-')[0]}` })} className="chip">{t('trip.city_tokyo')}</button>
                            <button onClick={() => navigate({ to: i18n.language.split('-')[0] === 'en' ? '/' : `/${i18n.language.split('-')[0]}` })} className="chip">{t('trip.city_new_york')}</button>
                            <button onClick={() => navigate({ to: i18n.language.split('-')[0] === 'en' ? '/' : `/${i18n.language.split('-')[0]}` })} className="chip">{t('trip.city_dubai')}</button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
